var exports = {
  "kL": "StatusSlate.module__container___Qzdldn",
  "Nb": "StatusSlate.module__fullHeight___Qzdldn",
  "Kk": "StatusSlate.module__icon___Qzdldn",
  "DD": "StatusSlate.module__title___Qzdldn",
  "h_": "StatusSlate.module__description___Qzdldn",
  "o1": "StatusSlate.module__actions___Qzdldn",
};

module.exports = exports;
